<!--站点/管理页 价格修改弹出项-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            <el-page-header
                @back="cancel"
                :content="'修改价格'"
                class="pt-1 pl-n3"
                :style="{ color: theme.pageFontColor }"
            ></el-page-header>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <v-card flat width="100%">
                <price-table
                    ref="priceTable"
                    :applyPrice="applyPrice"
                    @modify="modify"
                    v-if="isApply"
                />
            </v-card>
            <div style="width:100%;" class="mt-7">
                <select-site
                    class="float-left"
                    v-if="isSite"
                    :width="'250%'"
                    :multiple="multiple"
                    @choose="choose"
                    :selectSite="siteIds"
                />
                <div style="width:20%" class="float-right">
                    <el-tooltip
                        :content="multiple == true ? '应用到多个站点' : '只应用到当前站点'"
                        placement="top"
                    >
                        <el-switch
                            v-model="multiple"
                            active-text="多选"
                            inactive-text="单选"
                            active-color="#13ce66"
                            inactive-color="#d9d9d9"
                        ></el-switch>
                    </el-tooltip>
                </div>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="apply()" class="float-lg-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import PriceTable from "@/components/Table/PriceTable";
import SelectSite from "@/components/SelectSite";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "ApplyPrice",
    data() {
        return {
            siteIds: null, //选中的站点
            priceData: null, //价格
            isApply: true,
            isSite: true,
            multiple: false, //单选多选
        };
    },
    components: {
        PriceTable,
        SelectSite,
    },
    updated() {
        if (this.multiple) {
        } else {
            this.siteIds = this.siteId;
        }
    },
    mounted() {
        if (this.multiple) {
            this.siteIds.push(this.JsonData(this.siteId));
        } else {
            this.siteIds = this.siteId;
        }
    },
    computed: {
        ...mapState(["theme"]),
    },
    props: {
        applyPrice: Array, //价格
        siteId: Number, //站点信息
        area: Object,
    },
    watch: {
        applyPrice() {
            this.isApply = false;
            this.$nextTick(() => {
                this.isApply = true;
            });
        },
        siteId: {
            handler(val) {
                this.isSite = false;
                this.$nextTick(() => {
                    this.isSite = true;
                });
                if (this.multiple) {
                    this.siteIds = [];
                    this.siteIds.push(val);
                } else {
                    this.siteIds = null;
                    this.siteIds = val;
                }
            },
            deep: true,
        },
        multiple: {
            handler(val) {
                this.isSite = false;
                this.$nextTick(() => {
                    this.isSite = true;
                });
                if (val) {
                    this.siteIds = [];
                    this.siteIds.push(this.siteId);
                } else {
                    this.siteIds = null;
                    this.siteIds = this.siteId;
                }
            },
            deep: true,
        },
    },
    methods: {
        refresh() {},
        /*选择站点*/
        choose(site) {
            if (this.multiple) {
                this.siteIds = site.siteIds;
            } else {
                this.siteIds = site.siteId;
            }
        },
        /*取消*/
        cancel() {
            this.siteIds = null;
            this.$emit("noApply");
            this.$refs.priceTable.priceDataF();
        },
        /*确定修改*/
        apply() {
            //未修改
            if (this.priceData == null) {
                console.log("未修改数据表中的值");
            }
            if (this.multiple) {
            } else {
                let params = {
                    postData: { stationInfo: { price: this.priceData, id: this.siteIds } },
                    callback: () => {
                        this.$emit("refresh", this.area.label);
                        this.cancel();
                    },
                };
                // console.log(params);
                store.dispatch("updateStation", params);
            }
        },
        modify(data) {
            this.priceData = data;
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
